<i18n>
{
	"no" : {
		"inboundEdi" : "Inngående EDI",
		"outboundEdi" : "Utgående EDI"
	},
	"en": {
		"inboundEdi" : "Inbound Edi",
		"outboundEdi" : "Outbound Edi"
	}
}
</i18n>
<template>
	<t-horizontal-panel>
		<SearchEdi slot="left" @setComponent="setCorrectComponent" />
		<OutboundEdiResults
			v-if="searchContentMetadata && searchContentMetadata.direction === $t('outboundEdi')"
		/>
		<InboundEdiResults v-if="searchContentMetadata && searchContentMetadata.direction === $t('inboundEdi')"/>
	</t-horizontal-panel>
</template>
<script>

import SearchEdi from './transmissionOverview/SearchEdi.vue';
import InboundEdiResults from './transmissionOverview/InboundEdiResults.vue';
import OutboundEdiResults from './transmissionOverview/OutboundEdiResults.vue';

export default {
	name: 'Edi',
	components: { SearchEdi, InboundEdiResults, OutboundEdiResults },
	data() {
		return {
			shouldShowMessageFile: false,
			messageContent: '',
			searchContentMetadata: null
		};
	},
	methods: {
		showMessageFile(messageContent) {
			this.shouldShowMessageFile = true;
			this.messageContent = messageContent;
		},

		setCorrectComponent(metaData) {
			this.searchContentMetadata = metaData;
		},
		close() {
			this.shouldShowMessageFile = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.message-contents{
	min-height: 500px;
}
</style>